import React, { useState, useEffect } from 'react';
import Header from '../../../components/header/Header';
import './styles.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ic_Next from '../../../assets/imgs/ic_Next.svg?react';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import { showNotificationDialog } from '../../../utils';
import { DEV_ENV_FLAG } from '../../../utils/Constants';

const LicenseListScreen = () => {
    const { t } = useTranslation();
    const [licensesData, setLicensesData] = useState<{ name: string }[]>();
    const [isLoading, setIsLoading] = useState(false);
    const [isNetworkError, setIsNetworkError] = useState(!navigator.onLine);

    useEffect(() => {
        const fetchLicenseData = async () => {
            setIsLoading(true);
            let id;
            try {
                id = setTimeout(() => {
                    setIsNetworkError(true);
                    throw new Error('timeout');
                }, 30 * 1000);

                // ライセンス情報を取得する。
                const response = await fetch(`/licenses.json`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                });
                let licenseData = await response.json();
                if (!licenseData) {
                    throw new Error('no licenses');
                }

                // 修正されたライセンス情報を取得する
                const fixedResponse = await fetch(`/fixedLicenses.json`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                });
                const fixedLicenseData = await fixedResponse.json();

                // 修正内容チェック
                let checkResult = DEV_ENV_FLAG && checkPatch(licenseData, fixedLicenseData);
                if (checkResult) {
                    console.log('ok!');
                }

                // ライセンス情報を修正する
                licenseData = { ...licenseData, ...fixedLicenseData };

                //修正後内容チェック
                checkResult = DEV_ENV_FLAG && checkLicenses(licenseData);
                if (checkResult) {
                    console.log('ok!');
                }

                setLicensesData(Object.values(licenseData));
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            } finally {
                clearTimeout(id);
                setIsLoading(false);
            }
        };
        if (navigator.onLine) {
            void fetchLicenseData();
        } else {
            showNotificationDialog('error', '', t('notification.title'), t('ticket-display.no-ticket-cache'));
        }
    }, [t]);

    /**
     * ライセンスの本文が全て書かれているかチェックする。
     * @param {Object} data
     * @returns
     */
    const checkLicenses = (data: Record<string, { licenseText?: string }>) => {
        const noLicenseTextlicenses: Record<string, { licenseText?: string }> = {};
        for (const key in data) {
            if (!(data[key].licenseText && data[key].licenseText !== 'none')) {
                console.log(key);
                noLicenseTextlicenses[key] = data[key];
            }
        }
        const allLicenseHaslicenseText = Object.keys(noLicenseTextlicenses).length === 0;
        if (!allLicenseHaslicenseText) {
            console.log(noLicenseTextlicenses);
        }
        return allLicenseHaslicenseText;
    };

    /**
     * パッチデータが正常にパッチできるかチェックする。
     * @param {Object} data 元データ
     * @param {Object} patch パッチデータ
     * @returns
     */
    const checkPatch = (
        data: Record<string, { repository: string; version: string; licenses: string }>,
        patch: Record<string, { repository: string; version: string; licenses: string }>,
    ) => {
        let hasSameRepository = true;
        let hasSameVersion = true;
        let hasSameLicenses = true;
        if (patch !== undefined) {
            for (const key in patch) {
                if (data[key] === undefined) {
                    console.log(`fixerror: ${key} does not exist`);
                    break;
                }
                if (data[key].repository !== patch[key].repository) {
                    hasSameRepository = false;
                    console.log(`fixerror: ${key} repository`);
                }
                if (data[key].version !== patch[key].version) {
                    hasSameVersion = false;
                    console.log(`fixerror: ${key} version`);
                }
                if (data[key].licenses !== patch[key].licenses) {
                    hasSameLicenses = false;
                    console.log(`fixerror: ${key} licenses`);
                }
            }
        }
        return hasSameRepository && hasSameVersion && hasSameLicenses;
    };

    return (
        <>
            {isLoading && <CenterLoading overFooter={false} />}
            <Header title={t('licenses.copyright-information')} redirect="/profile" />
            <div className="content-container scrollable">
                {!isNetworkError ? (
                    licensesData != null &&
                    licensesData.length > 0 &&
                    licensesData.map((license, index) =>
                        license.name !== '' ? (
                            <div key={index}>
                                <Link to={'/profile/licenses-content'} state={{ license: license }}>
                                    <div className="licenses-item-container">
                                        <span className="licenses-name">{`${license.name}`}</span>
                                        {React.createElement(ic_Next, { className: 'img-icon' })}
                                    </div>
                                </Link>
                            </div>
                        ) : null,
                    )
                ) : (
                    <div className="error-content">{t('ticket-display.no-ticket-cache')}</div>
                )}
            </div>
        </>
    );
};

export default LicenseListScreen;
